import React from "react";
import LinkedChartItem from "../../weekly-wins/LinkedChartItem";

export default function ({ charts, group }) {
  return (
    <div className={`row px-1  ${"grp_single_page_render_analytics_grow"}`}>
      {charts.map((item, idx) => {
        return (
          <div
            className={`col-md-6 col-12 grp_single_page_analytics_item_container`}
            key={item._id + idx}
          >
            <LinkedChartItem
              group={group}
              isGroups={true}
              removeChart={() => {}}
              chart={item}
              hideRemove={true}
            />
          </div>
        );
      })}
    </div>
  );
}
